export enum BookingTypeEnum {
    ALACARTE = 'ALACARTE',
    DAYGUEST = 'DAYGUEST',
    DISCOVERY = 'DISCOVERY',
    IMMERSIVE = 'IMMERSIVE',
    OWP_GOLF = 'OWP_GOLF',
    OWP_TENNIS = 'OWP_TENNIS',
    PERFORMANCE = 'PERFORMANCE',
    UNKNOWN = 'UNKNOWN',
    WELLNESS = 'WELLNESS',
}
